module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create":"Add"},"de":{"create":"Hinzufügen"},"fr":{"create":"Ajouter"},"it":{"create":"Aggiungi"}}')
  delete Component.options._Ctor
}
